/**
 * Replace input string with formated phone number
 * @param {*} value
 */
import { parsePhoneNumber, getAsYouType } from 'awesome-phonenumber'

//format phone for input
export function formatPhoneNumber(value, country) {
    const ayt = getAsYouType(country);
    return ayt.reset(value.replace(/\D+/g, ''));
}

export function validatePhoneNumber(value, country) {
    const pn = parsePhoneNumber(value, { regionCode: country })
    return pn.valid
}

//format phone for display
export function nationalFormatPhone(phone, country) {
    const pn = parsePhoneNumber(phone, { regionCode: country });
    return pn.valid ? pn.number.national : phone
}

export function internationalPhone(phone, country) {
    const pn = parsePhoneNumber(phone, { regionCode: country });
    return pn.valid ? pn.number.e164 : phone
}

export function formatAndValidatePhoneNumber(value, country) {
    const pn = parsePhoneNumber(value, { regionCode: country });
    const isValid = pn.valid
    return {
        isValid,
        national: isValid ? pn.number.national : value,
        international: isValid ? pn.number.e164 : value,
    }
}

export const countryPhoneCode = [
    { country: "US", code: "+1" },
    { country: "CA", code: "+1" },
    { country: "ES", code: "+34" },
    { country: "DE", code: "+49" },
    { country: "AU", code: "+61" },
    { country: "GB", code: "+44" },
    { country: "CZ", code: "+420" },
    { country: "FR", code: "+33" },  // France
    { country: "NZ", code: "+64" },  // New Zealand
    { country: "SG", code: "+65" }   // Singapore

]